import { render, staticRenderFns } from "./SettingsAliases.vue?vue&type=template&id=5a231dfe&"
import script from "./SettingsAliases.vue?vue&type=script&lang=js&"
export * from "./SettingsAliases.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAliases.vue?vue&type=style&index=0&id=5a231dfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports